import { PaginationResponse } from "models/pagination-response";
import { IDocumentoSetorialPagedRequest } from "models/request/documento-setorial-paged-request";
import { IDocumentoSetorialPagedResponse } from "models/response/documento-setorial-paged-response";
import { ITipoDocumentoSetorialResponse } from "models/response/tipo-documento-setorial-response";
import { IAreaTransparenciaSetorialResponse } from "models/response/area-transparencia-setorial-response";
import { IDocumentoSetorialTotaisResponse } from "models/response/documento-setorial-totais-response";

export type DocumentosSetoriaisState = {
    documentos: PaginationResponse<IDocumentoSetorialPagedResponse>;
    documentoSetorialPagedRequest: IDocumentoSetorialPagedRequest;
    tipos: ITipoDocumentoSetorialResponse[];
    areas: IAreaTransparenciaSetorialResponse[];
    ultimaAtualizacao: string | null;
    totais: IDocumentoSetorialTotaisResponse;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setDocumentos = 'setDocumentos',
    setDocumentoSetorialPagedRequest = 'setDocumentoSetorialPagedRequest',
    setTipos = 'setTipos',
    setAreas = 'setAreas',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setTotais = 'setTotais',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const DocumentosSetoriaisReducer = (state: DocumentosSetoriaisState, action: any): DocumentosSetoriaisState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDocumentoSetorialPagedRequest:
            return { ...state, documentoSetorialPagedRequest: payload };
        case ACTION_TYPES.setDocumentos:
            return { ...state, documentos: payload };
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setAreas:
            return { ...state, areas: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setTotais:
            return { ...state, totais: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
